import { createReducer } from '@reduxjs/toolkit'

const initialState = {
    institutes: [],
    singleInstitute: null,
    acceptedInstitutes: [],
    acceptedInstitutesPagination: null,
    rejectedInstitutes: [],
    pendingInstitutes: [],
    pendingInstitutesPagination: null,
    inReviewInstitutes: [],
    institutesWithDelegation: [],
    institutesWithDelegationPagination: null,
    attachmentStatuses: {},
    ownerAttachmentStatuses: {},
    updatingStatus: false,
    updatingOwnerStatus: false,
    statusError: null,
    ownerStatusError: null,
    packageDetails: null,
    packageLoading: false,
    packageError: null,
    updatingVliContract: false,
    vliContractError: null,
    loading: false,
    error: null
}

export const InstituteReducer = createReducer(initialState, (builder) => {
    builder
        // Get All Institutes
        .addCase("GetAllInstitutesRequest", (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase("GetAllInstitutesSuccess", (state, action) => {
            state.loading = false;
            state.institutes = action.payload;
            state.error = null;
        })
        .addCase("GetAllInstitutesFailure", (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        // Get Single Institute
        .addCase("GetSingleInstituteRequest", (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase("GetSingleInstituteSuccess", (state, action) => {
            state.loading = false;
            state.singleInstitute = action.payload;
            state.error = null;
        })
        .addCase("GetSingleInstituteFailure", (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        // Get Accepted Institutes
        .addCase("GetAcceptedInstitutesRequest", (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase("GetAcceptedInstitutesSuccess", (state, action) => {
            state.loading = false;
            state.acceptedInstitutes = action.payload?.data || action.payload;
            state.acceptedInstitutesPagination = action.payload?.pagination || null;
            state.error = null;
        })
        .addCase("GetAcceptedInstitutesFailure", (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        // Get Rejected Institutes
        .addCase("GetRejectedInstitutesRequest", (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase("GetRejectedInstitutesSuccess", (state, action) => {
            state.loading = false;
            state.rejectedInstitutes = action.payload;
            state.error = null;
        })
        .addCase("GetRejectedInstitutesFailure", (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        // Get Pending Institutes
        .addCase("GetPendingInstitutesRequest", (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase("GetPendingInstitutesSuccess", (state, action) => {
            state.loading = false;
            state.pendingInstitutes = action.payload?.data || action.payload;
            state.pendingInstitutesPagination = action.payload?.pagination || null;
            state.error = null;
        })
        .addCase("GetPendingInstitutesFailure", (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        // Get In-Review Institutes
        .addCase("GetInReviewInstitutesRequest", (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase("GetInReviewInstitutesSuccess", (state, action) => {
            state.loading = false;
            state.inReviewInstitutes = action.payload;
            state.error = null;
        })
        .addCase("GetInReviewInstitutesFailure", (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        // Get Institutes With Delegation
        .addCase("GetInstitutesWithDelegationRequest", (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase("GetInstitutesWithDelegationSuccess", (state, action) => {
            state.loading = false;
            state.institutesWithDelegation = action.payload?.data || action.payload || [];
            state.institutesWithDelegationPagination = action.payload?.pagination || null;
            state.error = null;
        })
        .addCase("GetInstitutesWithDelegationFailure", (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        // Get Attachment Statuses
        .addCase("GetAttachmentStatusesRequest", (state) => {
            state.loading = true;
            state.statusError = null;
        })
        .addCase("GetAttachmentStatusesSuccess", (state, action) => {
            state.loading = false;
            state.attachmentStatuses = action.payload;
            state.statusError = null;
        })
        .addCase("GetAttachmentStatusesFailure", (state, action) => {
            state.loading = false;
            state.statusError = action.payload;
        })
        // Update Attachment Status
        .addCase("UpdateAttachmentStatusRequest", (state) => {
            state.updatingStatus = true;
            state.statusError = null;
        })
        .addCase("UpdateAttachmentStatusSuccess", (state, action) => {
            state.updatingStatus = false;
            state.attachmentStatuses = action.payload;
            state.statusError = null;
        })
        .addCase("UpdateAttachmentStatusFailure", (state, action) => {
            state.updatingStatus = false;
            state.statusError = action.payload;
        })
        // Update Institute Details (Admin)
        .addCase("UpdateInstituteDetailsRequest", (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase("UpdateInstituteDetailsSuccess", (state, action) => {
            state.loading = false;
            const payload = action.payload?.data || action.payload;
            state.singleInstitute = payload;
            state.error = null;
        })
        .addCase("UpdateInstituteDetailsFailure", (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        // Get Package Details
        .addCase("GetPackageDetailsRequest", (state) => {
            state.packageLoading = true;
            state.packageError = null;
        })
        .addCase("GetPackageDetailsSuccess", (state, action) => {
            state.packageLoading = false;
            state.packageDetails = action.payload?.data || action.payload;
            state.packageError = null;
        })
        .addCase("GetPackageDetailsFailure", (state, action) => {
            state.packageLoading = false;
            state.packageError = action.payload;
        })
        // Update Institute Package Details
        .addCase("UpdateInstitutePackageDetailsRequest", (state) => {
            state.updatingPackageDetails = true;
            state.packageDetailsError = null;
        })
        .addCase("UpdateInstitutePackageDetailsSuccess", (state, action) => {
            state.updatingPackageDetails = false;
            state.packageDetailsError = null;
            // Update the singleInstitute with the new PackageDetails
            if (state.singleInstitute) {
                state.singleInstitute.PackageDetails = action.payload?.data?.PackageDetails;
            }
        })
        .addCase("UpdateInstitutePackageDetailsFailure", (state, action) => {
            state.updatingPackageDetails = false;
            state.packageDetailsError = action.payload;
        })
        // Update Institute Package Status (Approve)
        .addCase("UpdateInstitutePackageStatusRequest", (state) => {
            state.updatingPackageDetails = true;
            state.packageDetailsError = null;
        })
        .addCase("UpdateInstitutePackageStatusSuccess", (state, action) => {
            state.updatingPackageDetails = false;
            state.packageDetailsError = null;
            // Update the singleInstitute with the new packageStatus
            if (state.singleInstitute) {
                state.singleInstitute.packageStatus = action.payload?.data?.packageStatus || 'Approved';
            }
        })
        .addCase("UpdateInstitutePackageStatusFailure", (state, action) => {
            state.updatingPackageDetails = false;
            state.packageDetailsError = action.payload;
        })
        // Send Owner Details Approved Payment Email
        .addCase("SendOwnerDetailsApprovedPaymentEmailRequest", (state) => {
            state.sendingPaymentEmail = true;
            state.paymentEmailError = null;
        })
        .addCase("SendOwnerDetailsApprovedPaymentEmailSuccess", (state, action) => {
            state.sendingPaymentEmail = false;
            state.paymentEmailError = null;
            state.paymentEmailData = action.payload?.data;
        })
        .addCase("SendOwnerDetailsApprovedPaymentEmailFailure", (state, action) => {
            state.sendingPaymentEmail = false;
            state.paymentEmailError = action.payload;
        })
        // Update Institute VLI Contract
        .addCase("UpdateInstituteVliContractRequest", (state) => {
            state.updatingVliContract = true;
            state.vliContractError = null;
        })
        .addCase("UpdateInstituteVliContractSuccess", (state, action) => {
            state.updatingVliContract = false;
            state.vliContractError = null;
            // Update the vliContract in the singleInstitute if it exists
            if (state.singleInstitute) {
                state.singleInstitute.vliContract = action.payload?.data?.newStatus;
            }
        })
        .addCase("UpdateInstituteVliContractFailure", (state, action) => {
            state.updatingVliContract = false;
            state.vliContractError = action.payload;
        })
        // Get Owner Attachment Statuses
        .addCase("GetOwnerAttachmentStatusesRequest", (state) => {
            state.loading = true;
            state.ownerStatusError = null;
        })
        .addCase("GetOwnerAttachmentStatusesSuccess", (state, action) => {
            state.loading = false;
            state.ownerAttachmentStatuses = action.payload;
            state.ownerStatusError = null;
        })
        .addCase("GetOwnerAttachmentStatusesFailure", (state, action) => {
            state.loading = false;
            state.ownerStatusError = action.payload;
        })
        // Update Owner Attachment Status
        .addCase("UpdateOwnerAttachmentStatusRequest", (state) => {
            state.updatingOwnerStatus = true;
            state.ownerStatusError = null;
        })
        .addCase("UpdateOwnerAttachmentStatusSuccess", (state, action) => {
            state.updatingOwnerStatus = false;
            // Merge the updated field(s) into existing statuses to avoid resetting others
            state.ownerAttachmentStatuses = {
                ...state.ownerAttachmentStatuses,
                ...(action.payload || {})
            };
            state.ownerStatusError = null;
        })
        .addCase("UpdateOwnerAttachmentStatusFailure", (state, action) => {
            state.updatingOwnerStatus = false;
            state.ownerStatusError = action.payload;
        })
        // Send Conditional Feedback Email
        .addCase("SendConditionalFeedbackEmailRequest", (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase("SendConditionalFeedbackEmailSuccess", (state, action) => {
            state.loading = false;
            state.error = null;
        })
        .addCase("SendConditionalFeedbackEmailFailure", (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
});
